import dispatcher from 'dispatcher';
import Api from 'utils/api';
import * as actionConstants from 'utils/ActionConstants';
import axios from 'axios';

export const login = async form => {
    console.log('SET TIME OUT');
    try {
        dispatcher.dispatch({ type: actionConstants.LOGIN });
        const auth = await Api.login(form);
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + auth.data.auth.authToken;
        dispatcher.dispatch({
            type: actionConstants.LOGIN_SUCCESS,
            payload: auth.data.auth
        });
        await Api.getProfile(auth.data.auth.user._id);
    } catch (error) {
        console.error(error);
        dispatcher.dispatch({
            type: actionConstants.LOGIN_FAILURE,
            payload: error
        });
    }

    // setTimeout(() => {
    //     console.log('TIME OUT EXECUTED');

    // }, 1000);

    //dispatcher.dispatch({type: action.LOGGED_IN});
};

// import * as ActionConstants from "../../utils/ActionConstants"
// import * as Strings from "../../utils/strings";

// //TODO: refactor ErrorStore to parse ERROR__ from type and remove duplicate dispatches
// export function calcQuote(quoteForm) {
//     Api.calcQuote(quoteForm).then((data) => {
//         console.log("QUOTE ACTION: ", data);
//         if(!data.data.error) {
//             data.data.quote.vid =
//             dispatcher.dispatch({
//                 type: ActionConstants.CREATED_QUOTE,
//                 payload: data.data.quote
//             });
//         }else{
//             dispatcher.dispatch({type:ActionConstants.ERROR_CREATING_QUOTE});
//             dispatcher.dispatch({
//                 type: ActionConstants.ERROR,
//                 payload: {
//                     title: Strings.QUOTES_ERROR_CREATING_QUOTE_TITLE,
//                     message: data.data.error
//                 }
//             });
//         }

//     }).catch((error)=>{
//         dispatcher.dispatch({type:ActionConstants.ERROR_CREATING_QUOTE});
//         dispatcher.dispatch({
//             type: ActionConstants.ERROR,
//             payload: {
//                 title: Strings.QUOTES_ERROR_CREATING_QUOTE_TITLE,
//                 message: Strings.QUOTES_ERROR_CREATING_QUOTE_MSG
//             }
//         });
//     });

// }
// export function createQuote(){
//     dispatcher.dispatch({
//         type:ActionConstants.CREATE_QUOTE,
//         payload: "ous"
//     })
// }

// export function selectedTerms(checkboxStates){
//     dispatcher.dispatch({
//         type:ActionConstants.SELECTED_TERMS,
//         payload: checkboxStates
//     })
// }
// export function previewQuote(contactDetails){
//     dispatcher.dispatch({
//         type:ActionConstants.PREVIEW_QUOTE,
//         payload: contactDetails
//     })

// }
// export function navigateBack(){
//     dispatcher.dispatch({
//         type:ActionConstants.QUOTE_NAV_BACK

//     })

// }

// export function sendToCustomer(quote){
//     dispatcher.dispatch({
//         type:ActionConstants.SEND_QUOTE_TO_CUSTOMER,
//         payload: quote
//     })
//     Api.sendQuote(quote).then((data) => {
//         console.log("QUOTE ACTION: ", data);
//         if(!data.data.error) {

//             dispatcher.dispatch({
//                 type: ActionConstants.QUOTE_SENT,
//                 payload: data.data.quote
//             });
//             dispatcher.dispatch({
//                 type: ActionConstants.NOTIFY_NEW,
//                 payload: {
//                     title : Strings.QUOTES_NOTIFICATION_SENT_TITLE,
//                     body : Strings.QUOTES_NOTIFICATION_SENT_BODY
//                 }
//             });
//         }else{
//             dispatcher.dispatch({
//                 type:ActionConstants.ERROR_SENDING_QUOTE,
//                 payload: data.data.error

//             });
//             dispatcher.dispatch({
//                 type: ActionConstants.ERROR,
//                 payload: {
//                     title: Strings.QUOTES_ERROR_SENDING_QUOTE_TITLE,
//                     message: data.data.error
//                 }
//             });
//         }

//     }).catch((error)=>{
//         dispatcher.dispatch({
//             type:ActionConstants.ERROR_SENDING_QUOTE,
//             payload: error
//         });
//         dispatcher.dispatch({
//             type: ActionConstants.ERROR,
//             payload: {
//                 title: Strings.QUOTES_ERROR_SENDING_QUOTE_TITLE,
//                 message: Strings.QUOTES_ERROR_SENDING_QUOTE_MSG
//             }
//         });
//     });

// }



// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/login/LoginActions.js